(function () {
  const outingsEventsGamesMatchPlaysApp = function () {
    let dragulaRef;

    const removeMatchPlay = function (e) {
      window.stopEvent(e);
      $(this)
        .closest(".card")
        .find("input")
        .each((_, el) => $(el).val(""));
      const html = $(this).parent().parent().next(".js-match-plays-container")[0].innerHTML;
      $(".js-teams-container")[0].innerHTML += html;
      $(this).parent().parent().parent().parent().remove();
    };

    const dropTeam = function (el, target, source) {
      const matchPlayId = $(target).attr("data-match-play-id");
      $(el).find("input").val(matchPlayId);
    };

    const setupDragAndDrop = function () {
      dragulaRef = dragula($(".js-teams-container, .js-match-plays-container").toArray(), {
        accepts: function (el, target, handle) {
          return $(target).find(".team").length < 2;
        },
      }).on("drop", dropTeam);
    };

    const addMatchPlay = function (e) {
      window.stopEvent(e);
      const template = $(".add-template")[0].outerHTML;
      const random = parseInt(Math.random(1000) * 1000000);
      template.replaceAll("##ID##", random);
      $(".js-match-plays")[0].innerHTML += template;
      $(".js-match-plays .add-template").removeClass("add-template d-none");
      dragulaRef.containers.push(
        $(".js-match-plays .card:last-child").find(".js-match-plays-container")[0]
      );
    };

    $(document).on("click", ".add-match-play", addMatchPlay);
    $(document).on("click", ".remove-match-play", removeMatchPlay);

    $(document).on("turbolinks:load", () => {
      if (!$("body").hasClass("controller-outings-match_plays")) return;

      setupDragAndDrop();
    });
  };

  if (typeof window !== "undefined") {
    window.outingsEventsGamesMatchPlaysApp = outingsEventsGamesMatchPlaysApp();
  }
})();
